import React, { Component } from 'react';
/* eslint-disable */
import { Form, FormGroup, Label, Input } from 'reactstrap';

export default class ContactUsForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobile: false,
            msgCount: 0,
            maxMsg: 1000,
            msg: ""
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.setState({ mobile: true });
        }
    }
    messageHandler = (e) => {
        const value = e.target.value
        if (value && value.length) {
            this.setState({ msg: value, msgCount: value.length })
        } else {
            this.setState({ msgCount: 0 })
        }
    }

    submitForm = (e) => e.preventDefault()

    render() {
        const { mobile, maxMsg, msgCount } = this.state;
        return (
            <React.Fragment>
                <div className="container contact-margin">
                    <div className="contactus-bg">
                        <div className={!mobile ? "row text-left" : "row"}>
                            <div className="col-md-4 contact-column">
                                <h4 className="sales-header">Contact Sales</h4>
                                <div className="box-contact">
                                    <h3 className="text-box">Contact-Info</h3>
                                    <p className="contact-number">
                                        Detecon Al Saudia Co.Ltd.
                                        P.O.Box 22135,
                                        Riyadh 11495,
                                        Kingdom of Saudi Arabia
                                    </p>
                                    <div className="mt-3 mb-2">
                                        <a className="link-email" href="mailto:info@detasad.com">info@detasad.com</a>
                                    </div>
                                </div>
                                <div className="box-contact">
                                    <h3 className="text-box">Phone</h3>
                                    <p className="contact-number">+966 92000 1221</p>
                                    <h3 className="text-box">FAX</h3>
                                    <p className="contact-number">+966 11 249 78 87</p>
                                </div>

                            </div>
                            <div className="col-md-2"></div>
                            <div className={"col-md-6 contact-column "}>
                                <h4 className="sales-header">General Inquiry</h4>
                                <Form>
                                    <div className="row mt-5">
                                        <div className="col-md-6">
                                            <FormGroup>
                                                <Input required={true} className="contact-field" type="text" name="fname" placeholder="First Name" />
                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6">
                                            <FormGroup>
                                                <Input className="contact-field" type="text" name="lname" placeholder="Last Name" />
                                            </FormGroup>
                                        </div>
                                    </div>
 
                                        <div className="row">
                                            <div className="col-md-6">
                                                <FormGroup>
                                                    <Input
                                                        className="contact-field"
                                                        type="email"
                                                        name="email"
                                                        id="exampleEmail"
                                                        placeholder="Email Address"
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="col-md-6">
                                                <FormGroup>
                                                    <Input
                                                        className="contact-field"
                                                        type="text"
                                                        placeholder="Subject Message"
                                                    />
                                                </FormGroup>
                                            </div>
                                        </div>

                                        <FormGroup>
                                            <Input required={true} onChange={this.messageHandler} maxLength={250} rows="5" placeholder="Write your message here....." className="contact-field" type="textarea" name="text" id="exampleText" />
                                            <span className={!mobile ? "count-word" : ""}>{msgCount + "/" + maxMsg}</span>
                                        </FormGroup>
                                        <button className="btn btn-primary btn-submit-contact" type={'submit'}>Submit</button>
                                </Form>

                                <div className="google-map-code">
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d3622.275717862864!2d46.750925615443855!3d24.786010654340664!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3e2efe0e98040adf%3A0x54c5ef5788b35ba4!2sDetecon%20Al%20Saudia%20Co.%20Ltd%2C%20Ghirnatah%2C%20Riyadh%2022135%2C%20Saudi%20Arabia!3m2!1d24.786005799999998!2d46.7531143!5e0!3m2!1sen!2s!4v1598861448478!5m2!1sen!2s"
                                        width="100%"
                                        height="250"
                                        draggable={true}
                                        className="mt-4"
                                        frameborder="0"
                                        style={{ border: 0, borderRadius: "6px" }}
                                        allowfullscreen={true}
                                        aria-hidden="false"
                                        tabindex="0">
                                    </iframe>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}